

































































































































import { Component, Vue, Provide } from "vue-property-decorator";
import Base from "@/template/public/Base.vue";
import AppPrompt from "@/components/AppPrompt.vue";
import request from "@/api/tongliang/index";
import native from "@/common/Native";
import { Toast, List, PullRefresh, Dialog, Loading } from "vant";
// import Zan from "@/components/Zan.vue";
// import NewsItem from "@/components/NewsItem.vue";
import { IShareConfig, ICommentItem } from "@/api/types";
import { wxChatShare } from "@/common/wechat";
import { setImgSrc } from "@/common/Utils";
import { getData, time } from "@/common/dataCollect";
@Component({
  components: {
    VanList: List,
    VanPullRefresh: PullRefresh,
    AppPrompt,
    VanLoading: Loading
  }
})
export default class VideoPage extends Base {
  isOpen: boolean = false;
  public request = new request();
  private commentList: ICommentItem[] = [];
  protected newsItem: any = {
    createTime: ""
  };
  private newsId?: number;

  private lastCreateTime: string = "";
  private lastReplyId?: number;

  private loading: boolean = false;
  private finished: boolean = false;
  private isLoading: boolean = false;
  private isOpenInApp: boolean = false;
  private businessDetail: any = {
    isPraised: "",
    viewCount: "",
    praiseCount: "",
    replyCount: ""
  };
  private userInfo: any = {
    appId: "",
    sessionId: "",
    token: ""
  };
  private isRequestLoaded: boolean = false; //详情是否加载完成
  public appId: string = "";
  // 埋点
  startTime: string = "";
  endTime: string = "";
  dataSource = true;
  created() {
    this.startTime = time();
  }
  mounted() {
    this.infoClassifyId = this.$route.query.cid as string; // by zhanxin 新闻详情页统一用cid
    this.appId = (this.$route.query.appId as string) || "";
    (window as any).cq_callBack_reply = () => {
      this.onRefresh();
    };
    if (native.isOpenInApp()) {
      this.isOpenInApp = true;
      native.getUserInfo().then((response: any) => {
        this.userInfo = response;
      });
    } else {
      this.isOpenInApp = false;
    }
    this.getNewsDetails().then(() => {
      this.getComments();
      this.getBussinessDetail();
      this.getCount();
    });
  }
  /**到详情页 */
  toCommentDetail() {
    let param = {
      id: this.infoClassifyId,
      informationId: this.newsItem.informationId,
      sourceType: this.newsItem.sourceType,
      newsCommentType: this.newsItem.commentType
    };
    let jsonParam: any = {
      iOS: "CQCommentDetailController",
      Android: "goToFamous",
      par: param
    };
    if (native.isOpenInApp()) {
      native.pushToController(jsonParam);
    } else {
      Dialog.alert({
        message: "请前往下载" + this.shareInfo.appName + "客户端！",
        closeOnClickOverlay: true
      }).then(() => {
        // on close
        // obj.jumpToApp(this.shareJson.downloadUrl, this.shareJson);
        // window.location.href = this.downloadUrl;
        this.openApp(this.newsItem);
      });
    }
  }
  getNewsDetails() {
    // this.isLoading = true;
    return this.request
      .getNewsDetails(this.infoClassifyId)
      .then(result => {
        this.isRequestLoaded = true;
        if (result.code == 0) {
          this.newsItem = result.data;
          this.newsId = result.data.id;
          document.title = this.newsItem.title;
          this.newsItem.onlineTime = this.newsItem.onlineTime.toString();
          this.$nextTick(() => {
            setImgSrc(this.$refs.synopsisContent as Element);
            this.handleVideo();
            // 埋点
            this.endTime = time();
            if (this.dataSource) {
              getData(this.startTime, this.endTime, this.newsItem);
              this.dataSource = false;
            }
          });
          // 唤醒头部 赋值base.vue里detailGetAppId参数值
          this.getShareInfo(this.newsItem.appId);
          this.detailGetAppId = this.newsItem.appId;
        }
        this.isLoading = false;
      })
      .catch(() => {
        this.isRequestLoaded = true;
      });
  }
  getComments(isClear = true) {
    if (isClear) {
      // 如果要清除所有，重新加载，需要重置到第一页
      this.lastCreateTime = "";
      this.lastReplyId = undefined;
    }
    this.request
      .getCommentListPage(
        this.appId,
        this.userInfo.sessionId,
        this.newsItem.id,
        "1",
        this.lastCreateTime,
        this.lastReplyId,
        this.userInfo.token
      )
      .then(result => {
        if (isClear) {
          this.commentList = [];
        }
        if (result.data.dataList.length === 0) {
          this.finished = true;
        } else {
          this.commentList = this.commentList.concat(result.data.dataList);
          this.isLoading = false;
          this.loading = false;
          this.lastCreateTime = result.data.dataList.lastChild
            .createTime as string;
          this.lastReplyId = result.data.dataList.lastChild.replyId;
        }
      });
  }
  reply(item: ICommentItem) {
    if (this.isOpenInApp) {
      native.showNativeView("openCommentPage", "openCommentPage", {
        replyId: item.replyId + "",
        id: "",
        passiveReplyId: item.userId + "",
        passiveReplyName: item.userName
      });
    } else {
      Dialog.alert({
        message: "请前往下载" + this.shareInfo.appName + "客户端！",
        closeOnClickOverlay: true
      }).then(() => {
        // on close
        // obj.jumpToApp(this.shareJson.downloadUrl, this.shareJson);
        // window.location.href = this.downloadUrl;
        this.openApp(this.newsItem);
      });
    }
  }
  // getShareInfo() {
  //   this.request
  //     .getShareInfoMethod(this.appId)
  //     .then((response: IShareConfig) => {
  //       if (response.code >= 0) {
  //         this.shareInfo = response.data;
  //       }
  //     });
  // }
  onRefresh() {
    this.lastCreateTime = "";
    this.lastReplyId = undefined;
    this.finished = false;
    this.getNewsDetails().then(() => {
      this.getComments();
    });
  }
  goback() {
    window.history.back();
  }
  onLoad() {
    if (this.newsId) {
      this.getComments(false);
    }
  }
  /**业务详情 */
  getBussinessDetail() {
    this.request
      .getBussinessDetail(
        this.appId,
        this.userInfo.sessionId,
        // this.newsInfo.informationId,
        this.infoClassifyId,
        "1",
        this.userInfo.token
      )
      .then((response: any) => {
        if (response.code >= 0 && response.data) {
          this.businessDetail.isPraised = response.data.isPraised;
          wxChatShare(
            response.data.detailTitle,
            response.data.shareDescription,
            response.data.shareUrlWx,
            response.data.shareImgUrl
          );
        }
      });
  }
  getCount() {
    // 在app外才需要增加浏览量 接口做了ua判断不需要前端判断是否在app内
    this.request.getCount(this.appId, this.infoClassifyId).then((res: any) => {
      if (res.code >= 0 && res.data) {
        this.businessDetail.viewCount = res.data.showViewCount;
        this.businessDetail.praiseCount = res.data.showPraiseCount;
        this.businessDetail.replyCount = res.data.showReplyCount;
      }
    });
  }
  /**评论点赞 */
  doPraise(item: ICommentItem) {
    if (this.isOpenInApp) {
      native.goToken().then(res => {
        this.userInfo = res;
        this.request
          .doPraise(
            this.infoClassifyId,
            this.appId,
            this.userInfo.sessionId,
            item.replyId,
            1,
            "1",
            1,
            this.userInfo.token,
            new Date().getTime()
          )
          .then((response: any) => {
            if (response.code >= 0) {
              if (response.data) {
                this.getComments();
                //积分
                if (response.data.point && response.data.point > 0) {
                  try {
                    ZWY_CLOUD.showPointView({
                      message: "点赞成功！",
                      point: response.data.point
                    });
                  } catch (e) {
                    ZWY_CLOUD.appAlert({ message: "点赞成功！" });
                  }
                } else {
                  ZWY_CLOUD.appAlert({ message: "点赞成功！" });
                }
              }
            } else {
              if (response.code === -999992) {
                native.goToken().then(res => {
                  this.userInfo = res;
                });
              } else if (response.code === -101000134) {
                native.goForceToken().then(res => {
                  this.userInfo = res;
                });
              } else {
                ZWY_CLOUD.appAlert({ message: response.message });
              }
            }
          })
          .catch((error: any) => {
            ZWY_CLOUD.appAlert({ message: error.toString() });
          });
      });
    } else {
      Dialog.alert({
        message: "请前往下载" + this.shareInfo.appName + "客户端！",
        closeOnClickOverlay: true
      }).then(() => {
        // on close
        // obj.jumpToApp(this.shareJson.downloadUrl, this.shareJson);
        // window.location.href = this.downloadUrl;
        this.openApp(this.newsItem);
      });
    }
  }
  /**新闻点赞 */
  articleDoPraise() {
    if (this.isOpenInApp) {
      native.goToken().then(res => {
        this.userInfo = res;
        this.request
          .doPraise(
            this.infoClassifyId,
            this.appId,
            this.userInfo.sessionId,
            this.newsItem.informationId, // 暂时的评论id
            1,
            "1", // version
            0,
            this.userInfo.token,
            new Date().getTime()
          )
          .then((response: any) => {
            if (response.code >= 0) {
              if (response.data) {
                // 假点赞成功-图标变红和+1
                this.businessDetail.isPraised = true;
                isNaN(Number(this.businessDetail!.praiseCount))
                  ? ""
                  : (this.businessDetail!.praiseCount =
                      Number(this.businessDetail!.praiseCount) + 1);
                //积分
                if (response.data.point && response.data.point > 0) {
                  try {
                    ZWY_CLOUD.showPointView({
                      message: "点赞成功！",
                      point: response.data.point
                    });
                  } catch (e) {
                    ZWY_CLOUD.appAlert({ message: "点赞成功！" });
                  }
                } else {
                  ZWY_CLOUD.appAlert({ message: "点赞成功！" });
                }
              }
            } else {
              if (response.code === -999992) {
                native.goToken().then(res => {
                  this.userInfo = res;
                });
              } else if (response.code === -101000134) {
                native.goForceToken().then(res => {
                  this.userInfo = res;
                });
              } else {
                ZWY_CLOUD.appAlert({ message: response.message });
              }
            }
          });
      });
    } else {
      Dialog.alert({
        message: "请前往下载" + this.shareInfo.appName + "客户端！",
        closeOnClickOverlay: true
      }).then(() => {
        // on close
        // obj.jumpToApp(this.shareJson.downloadUrl, this.shareJson);
        // window.location.href = this.downloadUrl;
        this.openApp(this.newsItem);
      });
    }
  }
}
